import { mergeDeepRight } from 'ramda';
import { environment as defaults } from './environment.defaults';

/**
 * Dev env config with local override
 */
export const environment = mergeDeepRight(defaults, {
  endpoints: {
    apiUrl: 'https://apiuat.realtybid.com/',
    apiWebUrl: 'https://apiwebuat.realtybid.com/rest/RBIAPI/',
    photoPath: 'https://photosuat.realtybid.com/',
    downloadSearchResult: 'https://appuat.realtybid.com/downloadSearchResults.cfm',
  },
  clientPortalLinks: {
    dailyTasks: 'https://clientportal.uat.internal.realtybid.com/#/dailytasks',
    programManagers: 'https://clientportal.uat.internal.realtybid.com/#/pm',
    manageProperties: 'https://clientportal.uat.internal.realtybid.com/#/manageproperties',
    allDocuments: 'https://clientportal.uat.internal.realtybid.com/#/AllDocuments/',
    charts: 'https://clientportal.uat.internal.realtybid.com/#/charts',
    pbiDashboard: 'https://app.powerbi.com/reportEmbed?reportId=017c411b-911f-46b1-b468-f1f4e205a9d6&groupId=f9f2b861-b94e-4ee3-a4ce-ef4b547e4cc3&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZX19',
    pbiReportID: '017c411b-911f-46b1-b468-f1f4e205a9d6'
  },
  reportLinks: {
    auctionPerformance: 'https://appuat.realtybid.com/activityReport.cfm',
    contractStatus: 'https://appuat.realtybid.com/contractStatusReport.cfm',
    bidding: 'https://appuat.realtybid.com/biddingReport.cfm',
  },
  licenses: {
    googleMapsKey: 'AIzaSyDN_EuLyvnvODkvgKA2f9E6tr6mmcyOAQc',
    googleAnalyticsKey: 'G-2YHFJV8941',
    googleTagKey: 'GTM-M85D469B',

    weissWidgetsApiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo5ODQyfQ._xs5NnkA6xfAYlsPs602lrigSKtNPN0Ixssh891NMQM',
    recaptchaKey: '6LdtYawnAAAAAAIRY6G36-QnKgnYuj_pXM5B7VY9',
    cookiebotKey: 'f29c8432-8ee9-4f55-9ce3-76a6d5b626a4',
    newRelic: {
      agentID: '1120250964',
      applicationID: '1120250964',
    },
  },
  settings: {
    enableCookiebot: false,
  },
});
